import { Calculator } from "lucide-react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle
} from "../../../../components/ui/common/alert-dialog";
import { IngredientRegisterViewModel } from "../types/ingredientRegisterView.types";

interface CalculateConfirmDialogProps {
  vm: IngredientRegisterViewModel;
}

/** AlertDialog replacement for the legacy calculate `ConfirmModal`. */
const CalculateConfirmDialog = ({ vm }: CalculateConfirmDialogProps) => {
  return (
    <AlertDialog
      open={vm.calculateModalOpen}
      onOpenChange={open => {
        if (!open) vm.onCloseCalculateModal();
      }}
    >
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="tw-flex tw-items-center tw-gap-2">
            <Calculator className="tw-h-5 tw-w-5" />
            Calculation Ingredient Data
          </AlertDialogTitle>
          <AlertDialogDescription>
            Are you sure you have entered all the data for ingredient calculation?
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={vm.onCloseCalculateModal}>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={vm.onApproveCalculate}>Calculate</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default CalculateConfirmDialog;
